"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemeProviderStyles = exports.ContextOnlyThemeProvider = void 0;
var _react = require("react");
var _cdsCommon = require("@cbhq/cds-common");
var _usePaletteToCssVars = require("../color/usePaletteToCssVars");
var _useSpectrumClassName = require("../color/useSpectrumClassName");
var scaleCss = _interopRequireWildcard(require("../styles/scale"));
var _linaria = require("../utils/linaria");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Internally the `ThemeProvider` component includes a div element which is used to attach CSS variables that are needed for palette overrides.
 * If the div added by ThemeProvider is not desired, you can use this hook and attach the returned className and style prop to the element of your choice.
 * @returns object - { className: string for the CSS class containing the spectrum variable assignments, style: palette config as css variables i.e. `style={{ background: 'rgb(var(--blue60))' }}` }
 * @example
 *  <div {...useThemeProviderStyles()}>
 *    My app content
 *  </div>
 */
const useThemeProviderStyles = () => {
  const scale = (0, _cdsCommon.useScale)();
  const palette = (0, _usePaletteToCssVars.usePaletteToCssVars)();
  const spectrumClassName = (0, _useSpectrumClassName.useSpectrumClassName)();
  const activeScaleCss = scaleCss[scale];
  return (0, _react.useMemo)(() => ({
    className: (0, _linaria.cx)(activeScaleCss, spectrumClassName),
    style: palette
  }), [palette, activeScaleCss, spectrumClassName]);
};

/**
 * Used with useThemeProviderStyles if you need to override spectrum, palette or scale
 * @example
 * <ContextOnlyThemeProvider spectrum="dark">
 *  <div {...useThemeProviderStyles()}>
 *    My app content
 *  </div>
 * </ContextOnlyThemeProvider>
 */
exports.useThemeProviderStyles = useThemeProviderStyles;
const ContextOnlyThemeProvider = _cdsCommon.SystemProvider;
exports.ContextOnlyThemeProvider = ContextOnlyThemeProvider;